export const camelCaseToItalicSpaced = (input: string) => {
  return input.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase();
};

export const toCamelCase = (input: string) =>
  input
    ?.toLowerCase()
    .replace("_", " ")
    .split(" ")
    .map((word, index) =>
      index > 0 ? word[0].toUpperCase() + word.slice(1) : word
    )
    .join("");
